import { PUBLIC_ASSET_BASE } from '../config';

export const ADMIN_ROLES = ['owner', 'admin', 'superadmin'];

// Resolves an org logo to a full URL. Accepts a bare filename ("shomer.png" →
// logos/shomer.png), a full key ("logos/shomer.png"), or an absolute URL.
export function logoUrl(logoKey) {
  if (!logoKey) return null;
  if (/^https?:\/\//i.test(logoKey)) return logoKey;
  let key = String(logoKey).replace(/^\/+/, '');
  if (!key.includes('/')) key = 'logos/' + key;
  return PUBLIC_ASSET_BASE + key;
}
const AVATAR_COLORS = ['#6B5A3A', '#5E7046', '#94745A', '#6E6552', '#8A6D3E', '#4F5B47', '#7A6A45', '#A0663F', '#575039'];

export function initials(name, email) {
  const s = (name || email || '?').trim();
  const parts = s.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}
export function avatarColor(key) {
  let h = 0;
  for (const c of String(key)) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}
export function timeAgo(iso) {
  if (!iso) return 'never';
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 3600) return `${Math.max(1, Math.floor(s / 60))}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
export function statusOf(iso) {
  if (!iso) return 'inactive';
  const days = (Date.now() - new Date(iso).getTime()) / 86400000;
  if (days < 7) return 'active';
  if (days < 30) return 'idle';
  return 'inactive';
}
export function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
// A drill's `picture` field can be an image or a video — detect by extension.
export function mediaKind(url) {
  if (!url || typeof url !== 'string') return 'none';
  const u = url.toLowerCase().split('?')[0];
  if (/\.(mp4|mov|webm|m4v|ogv)$/.test(u)) return 'video';
  return 'image';
}

export function brandVars(org) {
  const b = (org && org.branding) || {};
  return {
    '--bg': b.background || '#F0EDE6',
    '--text': b.primary || '#000000',
    '--rail-bg': b.secondary || '#44412E',
    '--accent': b.accent || '#937C58',
    // Elevated rail surfaces (org switcher, active nav item, join-code box)
    // track the org accent; falls back to the original static olive.
    '--rail-elev': b.accent || '#504C36',
  };
}
